<div class="app-appearing-badge">
  <mat-icon>{{ icon }}</mat-icon>
  <span class="appearing-type">{{ actuationTypeLabel }}</span>
  <span class="appearing-name">
    {{ notaryAppearing.person?.name }}
    {{ notaryAppearing.person?.fatherLastName }}
  </span>
</div>
